// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1d-2";
export var blackBorderOnHover = "_1d-7";
export var cell = "_1d-6";
export var cellContainer = "_1d-3";
export var checked = "_1d-8";
export var disabled = "_1d-5";
export var featuredIconCellContainer = "_1d-9";
export var featuredIconTextContainer = "_1d-b";
export var featuredIconWrapper = "_1d-a";
export var noBorder = "_1d-c";
export var orangeSelectedRow = "_3l-3";
export var overflowableText = "_1d-0";
export var overflowableTextContainer = "_1d-1";
export var row = "_1f-0";
export var rowCheckboxCell = "_1d-4";
export var selectableTable = "_3l-2";